import { ErrorMessage, Form, Formik } from 'formik'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import Modal from 'react-bootstrap/Modal'
import { MoreVertical } from 'react-feather'
import Select from 'react-select'
import ReactTable from 'react-table'
import { toast } from 'react-toastify'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { X } from 'react-feather'
import { getLocations } from 'src/services/locations/locationsService'
import {
  getStockLocations,
  updateStockAddress
} from 'src/services/stock/stockService'
import * as Yup from 'yup'
import Button from '../../components/Button'
import FlexLayout from '../../components/FlexLayout'
import FormField from '../../components/Form/FormField'
import Loading from '../../components/Loading'
import Text from '../../components/Text'
import Helper from '../../services/Helper'
import stockapi from '../../services/StockApi'
import { formatDateUTC } from 'src/utils/formatDate'

const Adjustments = () => {
  const [barcodeUser, setBarcodeUser] = useState(undefined)
  const [localizacoes, setLocalizacoes] = useState([])
  const [error, setError] = useState('')
  const [dataTable, setDataTable] = useState([])
  const [selectedShed, setSelectedShed] = useState(undefined)
  const [selectedStreet, setSelectedStreet] = useState(undefined)
  const [selectedShelf, setSelectedShelf] = useState(undefined)
  const [selectedBin, setSelectedBin] = useState(undefined)
  const [disabledButtonChangeAddress, setDisabledButtonChangeAddress] = useState(false)
  const [disabledButtonChangeAmount, setDisabledButtonChangeAmount] = useState(false)
  const [disabledButtonChangeExpirationDate, setDisabledButtonChangeExpirationDate] = useState(false)
  const { fc, validateFc } = useFulfillmentCenter()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  const updateLocations = useCallback(async () => {
    const res = await getLocations(fc.id)
    if (!res.isOk) {
      toast.error('Falha ao carregar localizações!')
      return
    }

    setLocalizacoes(res.data.localizacoes)
    let listaGalpão = [
      ...new Set(res.data.localizacoes.map((item) => item.galpao))
    ]

    setSelectShed((prev) => {
      return {
        ...prev,
        options: listaGalpão
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))
      }
    })

    setSelectShedModal((prev) => {
      return {
        ...prev,
        options: listaGalpão
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))
      }
    })
  }, [fc.id])

  useEffect(() => {
    updateLocations()
  }, [updateLocations])

  const orderingSelect = (value1, value2) => {
    if (typeof value1 === 'number' && typeof value2 === 'number') {
      if (value1 < value2) {
        return -1
      }
      if (value1 < value2) {
        return 1
      }
      return 0
    } else if (typeof value1 === 'string' && typeof value2 === 'string') {
      return value1.localeCompare(value2, ['pt-BR', 'kn'], { numeric: true })
    }
  }

  const [selectShed, setSelectShed] = useState({
    isDisabled: false,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectStreet, setSelectStreet] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectShelf, setSelectShelf] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectBin, setSelectBin] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })

  const [selectedShedModal, setSelectedShedModal] = useState(undefined)
  const [selectedStreetModal, setSelectedStreetModal] = useState(undefined)
  const [selectedShelfModal, setSelectedShelfModal] = useState(undefined)
  const [selectedBinModal, setSelectedBinModal] = useState(undefined)
  const [itemAdjust, setItemAdjust] = useState({})

  const [selectShedModal, setSelectShedModal] = useState({
    isDisabled: false,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectStreetModal, setSelectStreetModal] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectShelfModal, setSelectShelfModal] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })
  const [selectBinModal, setSelectBinModal] = useState({
    isDisabled: true,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    options: []
  })

  const [showModal, setShowModal] = useState(false)
  const [typeAdjustment, setTypeAdjustment] = useState(0)
  const typesAdjustment = {
    address: 1,
    amount: 2,
    expirationDate: 3
  }
  const handleCloseModal = () => {
    setShowModal(false)
    setError('')
  }

  const [modalTitle, setModalTitle] = useState('')

  const streetRef = useRef()
  const shelfRef = useRef()
  const binRef = useRef()
  const streetModalRef = useRef()
  const shelfModalRef = useRef()
  const binModalRef = useRef()

  const handleChangeShed = (id_galpao) => {
    if (!showModal) {
      setSelectedShed(undefined)
      setSelectedStreet(undefined)
      setSelectedShelf(undefined)
      setSelectedBin(undefined)
      streetRef.current.state.value = null
      shelfRef.current.state.value = null
      binRef.current.state.value = null

      if (id_galpao) {
        setSelectedShed(id_galpao.value)

        let listaRuas = [
          ...new Set(
            localizacoes
              .filter((item) => item.galpao === id_galpao.value)
              .map((item) => item.rua)
          )
        ]
        listaRuas = listaRuas
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectStreet((prev) => {
          return { ...prev, options: listaRuas, isDisabled: false }
        })
      } else {
        setSelectStreet((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectShelf((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectBin((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    } else {
      setSelectedShedModal(undefined)
      setSelectedStreetModal(undefined)
      setSelectedShelfModal(undefined)
      setSelectedBinModal(undefined)
      streetModalRef.current.state.value = null
      shelfModalRef.current.state.value = null
      binModalRef.current.state.value = null

      if (id_galpao) {
        setSelectedShedModal(id_galpao.value)

        let listaRuas = [
          ...new Set(
            localizacoes
              .filter((item) => item.galpao === id_galpao.value)
              .map((item) => item.rua)
          )
        ]
        listaRuas = listaRuas
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectStreetModal((prev) => {
          return { ...prev, options: listaRuas, isDisabled: false }
        })
      } else {
        setSelectStreetModal((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectShelfModal((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectBinModal((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    }
  }

  const handleChangeStreet = (id_rua) => {
    if (!showModal) {
      setSelectedStreet(undefined)
      setSelectedShelf(undefined)
      setSelectedBin(undefined)
      shelfRef.current.state.value = null
      binRef.current.state.value = null

      if (selectedShed && id_rua) {
        setSelectedStreet(id_rua.value)

        let lista_pallete = [
          ...new Set(
            localizacoes
              .filter(
                (item) =>
                  item.galpao === selectedShed && item.rua === id_rua.value
              )
              .map((item) => item.posicao_pallete)
          )
        ]
        lista_pallete = lista_pallete
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectShelf((prev) => {
          return { ...prev, options: lista_pallete, isDisabled: false }
        })
      } else {
        setSelectShelf((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectBin((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    } else {
      setSelectedStreetModal(undefined)
      setSelectedShelfModal(undefined)
      setSelectedBinModal(undefined)
      shelfModalRef.current.state.value = null
      binModalRef.current.state.value = null

      if (selectedShedModal && id_rua) {
        setSelectedStreetModal(id_rua.value)

        let lista_pallete = [
          ...new Set(
            localizacoes
              .filter(
                (item) =>
                  item.galpao === selectedShedModal && item.rua === id_rua.value
              )
              .map((item) => item.posicao_pallete)
          )
        ]
        lista_pallete = lista_pallete
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectShelfModal((prev) => {
          return { ...prev, options: lista_pallete, isDisabled: false }
        })
      } else {
        setSelectShelfModal((prev) => {
          return { ...prev, isDisabled: true }
        })
        setSelectBinModal((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    }
  }

  const handleChangeShelf = (id_pallete) => {
    if (!showModal) {
      setSelectedShelf(undefined)
      setSelectedBin(undefined)
      binRef.current.state.value = null

      if (selectedShed && selectedStreet && id_pallete) {
        setSelectedShelf(id_pallete.value)

        let lista_escaninho = [
          ...new Set(
            localizacoes
              .filter(
                (item) =>
                  item.galpao === selectedShed &&
                  item.rua === selectedStreet &&
                  item.posicao_pallete === id_pallete.value
              )
              .map((item) => item.escaninho_nivel)
          )
        ]

        lista_escaninho = lista_escaninho
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectBin((prev) => {
          return { ...prev, options: lista_escaninho, isDisabled: false }
        })
      } else {
        setSelectBin((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    } else {
      setSelectedShelfModal(undefined)
      setSelectedBinModal(undefined)
      binModalRef.current.state.value = null

      if (selectedShedModal && selectedStreetModal && id_pallete) {
        setSelectedShelfModal(id_pallete.value)

        let lista_escaninho = [
          ...new Set(
            localizacoes
              .filter(
                (item) =>
                  item.galpao === selectedShedModal &&
                  item.rua === selectedStreetModal &&
                  item.posicao_pallete === id_pallete.value
              )
              .map((item) => item.escaninho_nivel)
          )
        ]

        lista_escaninho = lista_escaninho
          .map((item) => ({ label: item, value: item }))
          .sort((value1, value2) => orderingSelect(value1.value, value2.value))

        setSelectBinModal((prev) => {
          return { ...prev, options: lista_escaninho, isDisabled: false }
        })
      } else {
        setSelectBinModal((prev) => {
          return { ...prev, isDisabled: true }
        })
      }
    }
  }

  const handleChangeBin = (id_bin) => {
    if (!showModal) {
      setSelectedBin(undefined)

      if (id_bin) {
        setSelectedBin(id_bin.value)
      } else {
        setSelectedBin(undefined)
      }
    } else {
      setSelectedBinModal(undefined)

      if (id_bin) {
        setSelectedBinModal(id_bin.value)
      } else {
        setSelectedBinModal(undefined)
      }
    }
  }

  const handleSendFilters = async () => {
    setshowLoading(true)

    const res = await getStockLocations(
      fc.id,
      selectedShed,
      selectedStreet || null,
      selectedShelf || null,
      selectedBin || null
    )

    if (!res.isOk) {
      toast.error('Falha ao carregar estoque!')
      setshowLoading(false)
      return
    }

    const stock = res.data.estoque.map((item) => {
      return {
        ...item,
        data_validade: formatDateUTC(item.data_validade, 'DD/MM/YYYY'),
        endereco: `${item.galpao}-${item.rua}-${item.posicao_pallete}-${item.escaninho_nivel}`,
        acao: (
          <FlexLayout align="center" justify="center">
            <Dropdown>
              <Dropdown.Toggle
                as={MoreVertical}
                id="dropdown"
                aria-label="Ações"
              />
              <Dropdown.Menu aria-label="Ações">
                <Dropdown.Item
                  onClick={() => {
                    setShowModal(true)
                    setTypeAdjustment(typesAdjustment.amount)
                    setItemAdjust(item)
                    setModalTitle('Ajuste Quantidade')
                  }}
                >
                  Ajuste de Quantidade
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setShowModal(true)
                    setTypeAdjustment(typesAdjustment.address)
                    setItemAdjust(item)
                    setModalTitle('Ajuste Endereço')
                  }}
                >
                  Ajuste de Endereço
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setShowModal(true)
                    setTypeAdjustment(typesAdjustment.expirationDate)
                    setItemAdjust(item)
                    setModalTitle('Ajuste Data de Validade')
                  }}
                >
                  Ajuste Data de Validade
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </FlexLayout>
        )
      }
    })

    setDataTable(stock)
    setshowLoading(false)
  }

  const handleChangeAddress = async (values) => {
    setDisabledButtonChangeAddress(true)
    const response = await updateStockAddress(
      barcodeUser,
      itemAdjust.id_estoque_lote,
      itemAdjust.id_modelo,
      itemAdjust.id_localização,
      itemAdjust.id_lote,
      selectedShedModal,
      selectedStreetModal,
      selectedShelfModal,
      selectedBinModal,
      values.justification
    )

    if (!response.isOk) {
      toast.error('Falha ao atualizar o endereço no estoque!')
      setDisabledButtonChangeAddress(false)
      return
    }

    setError('')
    handleCloseModal()
    handleSendFilters()
    setDisabledButtonChangeAddress(false)
  }

  const handleChangeAmount = (amount, justification) => {
    setDisabledButtonChangeAmount(true)
    const options = {
      headers: {
        'user-barcode': barcodeUser
      }
    }

    const data = {
      id_estoque_lote: itemAdjust.id_estoque_lote,
      modelo_produto: itemAdjust.id_modelo,
      id_localizacao: itemAdjust.id_localização,
      id_lote: itemAdjust.id_lote,
      quantidade: amount,
      justificativa: justification,
      id_fc: fc.id
    }

    stockapi
      .post('/estoque/ajuste/quantidade', data, options)
      .then(() => {
        setError('')
        handleCloseModal()
        handleSendFilters()
        setDisabledButtonChangeAmount(false)
      })
      .catch((err) => {
        const errorMesssage = err.response.data.message
        setError(errorMesssage)
        setDisabledButtonChangeAmount(false)
      })
  }

  const handleChangeExpirationDate = (expiration_date) => {
    setDisabledButtonChangeExpirationDate(true)
    const options = {
      headers: {
        'user-barcode': barcodeUser
      }
    }
    const data = {
      id_estoque_lote: itemAdjust.id_estoque_lote,
      modelo_produto: itemAdjust.id_modelo,
      id_localizacao: itemAdjust.id_localização,
      id_lote: itemAdjust.id_lote,
      data_validade: expiration_date
    }

    stockapi
      .post('/estoque/ajuste/datavalidade', data, options)
      .then(() => {
        setError('')
        handleCloseModal()
        handleSendFilters()
        setDisabledButtonChangeExpirationDate(false)
      })
      .catch((err) => {
        const errorMesssage = err.response.data.message
        setError(errorMesssage)
        setDisabledButtonChangeExpirationDate(false)
      })
  }

  const [showLoading, setshowLoading] = useState(false)

  const handleChangeBarCodeUser = async (value) => {
    const isValid = await Helper.validateBarcodeUser(value)

    if (isValid) {
      setBarcodeUser(value)
    }

    return isValid
  }

  return (
    <>
      <Loading loading={showLoading} style={{ opacity: '80%' }} />
      <Text textType="header" text="adjust" />

      <FlexLayout style={{ margin: '20px 0 0 0' }}>
        <Formik
          initialValues={{
            barcodeUser: '',
            shedSelected: ''
          }}
          validationSchema={Yup.object().shape({
            barcodeUser: Yup.string()
              .required('form.required')
              .test(
                'barcodeUser',
                'receivement.form.error.barcodeUser',
                (values) => handleChangeBarCodeUser(values)
              ),
            shedSelected: Yup.string().required('form.required')
          })}
          onSubmit={() => {
            handleSendFilters()
          }}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={true}
        >
          {({ setFieldValue, handleSubmit, handleBlur }) => (
            <Form>
              <FlexLayout style={{ width: '300px' }} direction="column">
                <FormField
                  name="barcodeUser"
                  label="barcodeUser"
                  style={{ width: '300px', marginBottom: '20px' }}
                  onBlur={handleBlur}
                  fieldType="password"
                />

                <Text textType="defaut" text="receivement.form.address.shed" />
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={selectShed.isDisabled}
                  isLoading={selectShed.isLoading}
                  isClearable={selectShed.isClearable}
                  isSearchable={selectShed.isSearchable}
                  options={selectShed.options}
                  name="shedSelect"
                  placeholder="Selecione"
                  noOptionsMessage={() => {
                    return 'Sem Opções'
                  }}
                  onChange={(id_galpao) => {
                    setFieldValue(
                      'shedSelected',
                      id_galpao ? id_galpao.value : undefined
                    )
                    handleChangeShed(id_galpao)
                  }}
                ></Select>
                <ErrorMessage component={Text} name="shedSelected" />

                <Text
                  textType="defaut"
                  text="receivement.form.address.street"
                />
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={selectStreet.isDisabled}
                  isLoading={selectStreet.isLoading}
                  isClearable={selectStreet.isClearable}
                  isSearchable={selectStreet.isSearchable}
                  options={selectStreet.options}
                  name="streetSelect"
                  placeholder="Selecione"
                  ref={streetRef}
                  noOptionsMessage={() => {
                    return 'Sem Opções'
                  }}
                  onChange={(id_rua) => {
                    handleChangeStreet(id_rua)
                  }}
                ></Select>

                <Text textType="defaut" text="receivement.form.address.shelf" />
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={selectShelf.isDisabled}
                  isLoading={selectShelf.isLoading}
                  isClearable={selectShelf.isClearable}
                  isSearchable={selectShelf.isSearchable}
                  options={selectShelf.options}
                  name="shelfSelect"
                  placeholder="Selecione"
                  ref={shelfRef}
                  noOptionsMessage={() => {
                    return 'Sem Opções'
                  }}
                  onChange={(id_pallete) => {
                    handleChangeShelf(id_pallete)
                  }}
                ></Select>

                <Text textType="defaut" text="receivement.form.address.bin" />
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={selectBin.isDisabled}
                  isLoading={selectBin.isLoading}
                  isClearable={selectBin.isClearable}
                  isSearchable={selectBin.isSearchable}
                  options={selectBin.options}
                  name="binSelect"
                  placeholder="Selecione"
                  ref={binRef}
                  noOptionsMessage={() => {
                    return 'Sem Opções'
                  }}
                  onChange={(id_bin) => {
                    handleChangeBin(id_bin)
                  }}
                ></Select>

                <FlexLayout style={{ margin: '20px 0 0 0' }} justify="end">
                  <Button
                    type="submit"
                    text="Filtrar"
                    onClick={() => {
                      handleSubmit()
                    }}
                  ></Button>
                </FlexLayout>
              </FlexLayout>
            </Form>
          )}
        </Formik>
        {dataTable.length > 0 && (
          <ReactTable
            style={{
              fontSize: '0.7em',
              width: '100%',
              maxHeight: '90vh',
              marginTop: '-4vh',
              marginLeft: '40px',
              marginRight: '20px',
              overflowX: 'scroll'
            }}
            data={dataTable}
            showPageSizeOptions={true}
            showPageJump={false}
            onPageChange={() => {
              document.getElementsByClassName('rt-tbody')[0].scrollTop = 0
            }}
            pageSizeOptions={[20, 30, 50, 100, 200, 500]}
            getTdProps={() => {
              return {
                style: {
                  overflow: 'hidden'
                }
              }
            }}
            columns={[
              {
                Header: 'Lote',
                id: 'id_lote',
                accessor: 'id_lote',
                width: 80
              },
              {
                Header: 'Cod. Prod.',
                id: 'cod_produto',
                accessor: 'cod_produto',
                width: 100
              },
              {
                Header: 'Produto',
                id: 'descricao',
                accessor: 'descricao'
              },
              {
                Header: 'Qtd',
                id: 'quantidade',
                accessor: 'quantidade',
                width: 60,
                getProps: () => {
                  return {
                    style: {
                      textAlign: 'right'
                    }
                  }
                }
              },
              {
                Header: 'Validade',
                id: 'data_validade',
                accessor: 'data_validade',
                width: 130
              },
              {
                Header: 'Endereço',
                id: 'endereco',
                accessor: 'endereco',
                width: 80
              },
              {
                Header: 'Ações',
                id: 'acao',
                accessor: 'acao',
                width: 80,
                getProps: () => {
                  return {
                    style: {
                      overflow: 'visible'
                    }
                  }
                }
              }
            ]}
            defaultPageSize={20}
            className="-striped -highlight"
            previousText={'Anterior'}
            nextText={'Próxima'}
            loadingText={'Carregando...'}
            noDataText={'Sem registros'}
            pageText={'Página'}
            ofText={'de'}
            rowsText={'Registros'}
          />
        )}
      </FlexLayout>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <X cursor="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body>
          <FlexLayout
            justify="center"
            style={{
              display:
                showModal && typeAdjustment == typesAdjustment.address
                  ? 'flex'
                  : 'none'
            }}
          >
            <Formik
              initialValues={{
                justification: '',
                shedSelect: '',
                streetSelect: '',
                shelfSelect: '',
                binSelect: '',
                barcodeUser: barcodeUser
              }}
              validationSchema={Yup.object().shape({
                justification: Yup.string().required('form.required'),
                shedSelect: Yup.string().required('form.required'),
                streetSelect: Yup.string().required('form.required'),
                shelfSelect: Yup.string().required('form.required'),
                binSelect: Yup.string().required('form.required'),
                barcodeUser: Yup.string().required('form.required')
              })}
              validateOnChange={false}
              validateOnBlur
              onSubmit={(values) => {
                handleChangeAddress(values)
              }}
            >
              {({ setFieldValue }) => (
                <Form>
                  <FlexLayout direction="collumn" style={{ width: '300px' }}>
                    <Text
                      textType="defaut"
                      text="receivement.form.address.shed"
                    />
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isDisabled={selectShedModal.isDisabled}
                      isLoading={selectShedModal.isLoading}
                      isClearable={selectShedModal.isClearable}
                      isSearchable={selectShedModal.isSearchable}
                      options={selectShedModal.options}
                      name="shedSelect"
                      placeholder="Selecione"
                      noOptionsMessage={() => {
                        return 'Sem Opções'
                      }}
                      onChange={(id_galpao) => {
                        handleChangeShed(id_galpao)
                        setFieldValue('shedSelect', id_galpao)
                      }}
                    ></Select>
                    <ErrorMessage component={Text} name="shedSelect" />

                    <Text
                      textType="defaut"
                      text="receivement.form.address.street"
                    />
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isDisabled={selectStreetModal.isDisabled}
                      isLoading={selectStreetModal.isLoading}
                      isClearable={selectStreetModal.isClearable}
                      isSearchable={selectStreetModal.isSearchable}
                      options={selectStreetModal.options}
                      name="streetSelect"
                      placeholder="Selecione"
                      ref={streetModalRef}
                      noOptionsMessage={() => {
                        return 'Sem Opções'
                      }}
                      onChange={(id_rua) => {
                        handleChangeStreet(id_rua)
                        setFieldValue('streetSelect', id_rua)
                      }}
                    ></Select>
                    <ErrorMessage component={Text} name="streetSelect" />

                    <Text
                      textType="defaut"
                      text="receivement.form.address.shelf"
                    />
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isDisabled={selectShelfModal.isDisabled}
                      isLoading={selectShelfModal.isLoading}
                      isClearable={selectShelfModal.isClearable}
                      isSearchable={selectShelfModal.isSearchable}
                      options={selectShelfModal.options}
                      name="shelfSelect"
                      placeholder="Selecione"
                      ref={shelfModalRef}
                      noOptionsMessage={() => {
                        return 'Sem Opções'
                      }}
                      onChange={(id_pallete) => {
                        handleChangeShelf(id_pallete)
                        setFieldValue('shelfSelect', id_pallete)
                      }}
                    ></Select>
                    <ErrorMessage component={Text} name="shelfSelect" />

                    <Text
                      textType="defaut"
                      text="receivement.form.address.bin"
                    />
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isDisabled={selectBinModal.isDisabled}
                      isLoading={selectBinModal.isLoading}
                      isClearable={selectBinModal.isClearable}
                      isSearchable={selectBinModal.isSearchable}
                      options={selectBinModal.options}
                      name="binSelect"
                      placeholder="Selecione"
                      ref={binModalRef}
                      noOptionsMessage={() => {
                        return 'Sem Opções'
                      }}
                      onChange={(id_bin) => {
                        handleChangeBin(id_bin)
                        setFieldValue('binSelect', id_bin)
                      }}
                    ></Select>
                    <ErrorMessage component={Text} name="binSelect" />

                    <FormField
                      name="justification"
                      label="adjust.form.justification"
                      inputType="textarea"
                    ></FormField>
                    {error && <Text style={{ color: 'red' }}>{error}</Text>}
                    <FlexLayout style={{ margin: '20px 0 0 0' }} justify="end">
                      <Button
                        type="submit"
                        text="adjust.form.button.address"
                        isDisabled={disabledButtonChangeAddress === true}
                      ></Button>
                    </FlexLayout>
                  </FlexLayout>
                </Form>
              )}
            </Formik>
          </FlexLayout>
          <FlexLayout
            justify="center"
            style={{
              display:
              showModal && typeAdjustment == typesAdjustment.amount
                  ? 'flex'
                  : 'none'
            }}
          >
            <Formik
              initialValues={{
                amount: '',
                justification: '',
                barcodeUser: barcodeUser
              }}
              validationSchema={Yup.object().shape({
                amount: Yup.number()
                  .required('form.required')
                  .min(0, 'form.amount.invalid'),
                justification: Yup.string().required('form.required'),
                barcodeUser: Yup.string().required('form.required')
              })}
              validateOnChange={false}
              validateOnBlur
              onSubmit={(values) => {
                handleChangeAmount(values.amount, values.justification)
              }}
            >
              {() => (
                <Form style={{ width: '300px' }}>
                  <FlexLayout direction="column">
                    <FormField
                      name="amount"
                      label="label.amount"
                      fieldType="number"
                    ></FormField>
                    <FormField
                      name="justification"
                      label="adjust.form.justification"
                      inputType="textarea"
                    ></FormField>
                    {error && <Text style={{ color: 'red' }}>{error}</Text>}
                  </FlexLayout>
                  <FlexLayout style={{ margin: '20px 0 0 0' }} justify="end">
                    <Button
                      type="submit"
                      text="adjust.form.button.amount"
                      isDisabled={disabledButtonChangeAmount === true}
                    ></Button>
                  </FlexLayout>
                </Form>
              )}
            </Formik>
          </FlexLayout>
          <FlexLayout
            justify="center"
            style={{
              display:
                showModal && typeAdjustment == typesAdjustment.expirationDate
                  ? 'flex'
                  : 'none'
            }}
          >
            <Formik
              initialValues={{
                expirationDate: moment(itemAdjust.data_validade)
                  .utc()
                  .format('YYYY-MM-DD'),
                barcodeUser: barcodeUser
              }}
              validationSchema={Yup.object().shape({
                barcodeUser: Yup.string().required('form.required'),
                expirationDate: Yup.date().required('form.required')
              })}
              validateOnChange={false}
              validateOnBlur
              onSubmit={(values) => {
                handleChangeExpirationDate(values.expirationDate)
              }}
            >
              {() => (
                <Form style={{ width: '300px' }}>
                  <FlexLayout direction="column">
                    <FormField
                      name="expirationDate"
                      label="label.expirationDate"
                      fieldType="date"
                    ></FormField>
                    {error && <Text style={{ color: 'red' }}>{error}</Text>}
                  </FlexLayout>
                  <FlexLayout style={{ margin: '20px 0 0 0' }} justify="end">
                    <Button
                      type="submit"
                      text="adjust.form.button.expirationDate"
                      isDisabled={disabledButtonChangeExpirationDate === true}
                    ></Button>
                  </FlexLayout>
                </Form>
              )}
            </Formik>
          </FlexLayout>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default Adjustments
